import { render, staticRenderFns } from "./FCXDisclaimer.vue?vue&type=template&id=265114f0&scoped=true"
import script from "./FCXDisclaimer.vue?vue&type=script&lang=js"
export * from "./FCXDisclaimer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265114f0",
  null
  
)

export default component.exports